import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { StaticDataConfig } from '../configs/static-data-config';
import { CookieService } from 'ngx-cookie-service';
import { AuthenticationService } from '../shared/services/authentication.service';
import { ENVIRONMENT } from '@libs/shared/injections/window';

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | any => {
  const cookieService: CookieService = inject(CookieService);
  const authService: AuthenticationService = inject(AuthenticationService);
  const domain: string = inject(ENVIRONMENT)?.cookieDomain;
  const affiliateArray: Array<string> = StaticDataConfig.affiliate;

  if (!authService.isAuthenticated()) {
    authService.logout();
    Object.keys(route.queryParams).forEach((key) => {
      if (affiliateArray.includes(key)) {
        cookieService.set(key, route.queryParams[key], 30, '/', domain);
      }
    });
    return false;
  }
  return true;
};
